import React from "react";
import clsx from "clsx";
import Accordion from '@mui/material/Accordion';
import Summary from '@mui/material/AccordionSummary';
import Details from '@mui/material/AccordionDetails';

interface AccordianProps {
  expanded: boolean;
  summary: React.ReactNode;
  content: React.ReactNode;
  bodyClassName?: string;
  summaryClassName?: string;
  onChange: () => void;
}

const Accordian: React.FC<AccordianProps> = ({
  expanded, summary, content, bodyClassName, summaryClassName, onChange
}) => {
  return (
    <div className="accordion accordion-custom-button">
      <Accordion
        classes={{
          root: clsx("card mb-4 border-radius-card accordion-item", expanded && "active"),
          heading: "accordion-header"
        }}
        expanded={expanded}
        onChange={onChange}
      >
        <Summary
          classes={{
            root: clsx("accordion-button", !expanded && "collapsed", summaryClassName),
            content: "m-0"
          }}
        >
          {summary}
        </Summary>
        <Details
          classes={{
            root: clsx("accordion-body", bodyClassName)
          }}
        >
          {content}
        </Details>
      </Accordion>
    </div>
  );
};

export default Accordian;